(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the blockname-block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @return  void
	 */
	const initializeBlock = function ($block) {
		$('.accordion-header', $block).click(function () {
			// Close all accordion items except the clicked one
			$('.accordion-content', $block)
				.not($(this).parent().find('.accordion-content'))
				.css('maxHeight', '0px')
				.removeClass('content-added');
			$('.faq-ic', $block)
				.not($(this).find('.faq-ic'))
				.html('+')
				.removeClass('minus-icon');

			var accordionContent = $(this).parent().find('.accordion-content');
			var accordionMaxHeight = accordionContent.css('maxHeight');
			var faqIcon = $(this).find('.faq-ic');

			if (accordionMaxHeight === '0px' || !accordionMaxHeight) {
				accordionContent.css(
					'maxHeight',
					accordionContent.prop('scrollHeight') + 32 + 'px'
				);
				faqIcon.html('-').addClass('minus-icon');
				$('.accordion-content', $block).addClass('content-added');
			} else {
				accordionContent.css('maxHeight', '0px');
				faqIcon.html('+').removeClass('minus-icon');
				$('.accordion-content', $block).removeClass('content-added');
			}
		});

		// Mark block as initialized
		$block.addClass('block-initialized');
	};

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('.faqs-block').each(function () {
			initializeBlock($(this));
		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction(
			'render_block_preview/type=faqs-block',
			function ($block) {
				initializeBlock($($block));
			}
		);
	}
})(jQuery);
